module.exports = __webpack_public_path__ + "img/1F1FB-1F1EA.66039b18.svg";